import React from 'react';
import { displayDateTime } from 'legacy/utils/dates';
import { useSelector } from 'react-redux';
import { getMlsIds } from 'selectors/mls';
import { useMlsDisclaimer } from 'legacy/hocs/useMlsDisclaimer';
import { MlsDisclaimer as styles } from 'legacy/css-modules';
const MLSCopyrightText = ({
  logoUrl,
  copyrightText,
  disclaimerText,
  refreshedDateTime
}) => (
  <div className={styles.MLSCopyrightText} data-hc-name={'mls-copyright'}>
    {logoUrl && <img src={logoUrl} alt="MLS logo" className={styles.MLSLogo} />}
    {disclaimerText && <p>{disclaimerText}</p>}
    {copyrightText && <p>{copyrightText}</p>}
    {refreshedDateTime && <p>Updated on {refreshedDateTime}</p>}
  </div>
);

export const MlsDisclaimer = ({ mlsId }) => {
  const mlsData = useMlsDisclaimer(mlsId);
  if (!mlsData) {
    return null;
  }
  return (
    <MLSCopyrightText
      logoUrl={mlsData.regulations?.logo}
      copyrightText={mlsData.regulations?.copyrightStatement}
      disclaimerText={mlsData.regulations?.disclaimer}
      refreshedDateTime={
        mlsData.lastRefreshed ? displayDateTime(mlsData.lastRefreshed) : '--'
      }
    />
  );
};

export const MlsDisclaimerFooter = () => {
  const mlsIds = useSelector(getMlsIds);
  return mlsIds.map((mlsId) => (
    <MlsDisclaimer key={`disclaimer-${mlsId}`} mlsId={mlsId} />
  ));
};
